// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_system_load.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";

/**
 * `LoadLevel` - load level of a backend processing queue
 *
 * @generated from enum com.diagnocat.model.LoadLevel
 */
export const LoadLevel = proto3.makeEnum(
  "com.diagnocat.model.LoadLevel",
  [
    {no: 0, name: "LoadLevel_InvalidValue"},
    {no: 1, name: "LoadLevel_Low"},
    {no: 2, name: "LoadLevel_Medium"},
    {no: 3, name: "LoadLevel_High"},
  ],
);

